import { BaseService } from '@/core/base-service';

export default class ScheduledNotificationService extends BaseService<any> {
  public constructor() {
    super('services/servicescard/api/scheduled-notification');
  }
}
